import React from "react";
import PropTypes from "prop-types";

type SVGCbProps = {
  //
};

const SVGCb: React.FC<SVGCbProps> = () => {
  return <svg width="60" height="40" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" version="1.1" x="0px" y="0px" viewBox="0 0 48.7 34.7" xmlSpace="preserve">
  <g id="Logo_CB__x3C__100">
    <g>
      <rect fill="#0a3d76" width="60" height="40"/>
    </g>
    <g>
      <path fill="#fff" d="M42,12.8c0-0.5-0.1-1-0.3-1.5c-0.2-0.5-0.5-0.9-0.8-1.2c-0.4-0.4-0.8-0.7-1.3-0.8c-0.5-0.2-1.1-0.2-1.9-0.2    H26.7v3.7v3.7h10.9c0.8,0,1.5-0.1,1.9-0.2c0.5-0.2,0.9-0.4,1.3-0.8c0.4-0.4,0.6-0.8,0.8-1.2C41.9,13.8,42,13.3,42,12.8"/>
      <path fill="#fff" d="M42,21.9c0-0.5-0.1-1-0.3-1.5c-0.2-0.5-0.5-0.9-0.8-1.2c-0.4-0.4-0.8-0.7-1.3-0.8c-0.5-0.2-1.1-0.2-1.9-0.2    H26.7v3.7v3.7h10.9c0.8,0,1.5-0.1,1.9-0.2c0.5-0.2,0.9-0.4,1.3-0.8c0.4-0.4,0.6-0.8,0.8-1.2C41.9,22.9,42,22.4,42,21.9"/>
      <path fill="#fff" d="M25.2,16.5c-0.4-4.8-3.8-8-9.2-8c-5.7,0-9.2,3.5-9.2,8.8c0,5.5,3.7,8.8,9.2,8.8c5.4,0,8.8-3.1,9.2-8h-9.3    v-1.7H25.2z"/>
    </g>
  </g>
  <g id="Logo_CB__x3E__100">
  </g>
  </svg>
};

SVGCb.propTypes = {
  //
};

export default SVGCb;
